export const TEST_EVENT_NAME = 'test_event';
export const DOWNLOAD_FLOW = 'download_flow';
export const DOWNLOAD_AGGREGATE = 'download_aggregate';
export const DOWNLOAD_TICKER_FLOW = 'download_ticker_flow';
export const DOWNLOAD_DARK_POOL = 'download_dark_pool';
export const OPC_BUILD_STRATEGY = 'opc_build_strategy';
export const FLOW_TOGGLE_SIDE_MODULE = 'flow_toggle_side_module';
export const FLOW_SIDE_BASIS_CHANGED = 'flow_side_basis_changed';
export const FLOW_METRIC_MODE_CHANGED = 'flow_metric_mode_changed';
export const FLOW_CHAIN_VIEW_OPENED = 'flow_chain_view_opened';
export const FLOW_EXPAND_PANE = 'flow_expand_pane';
export const FLOW_RESTORE_PANE = 'flow_restore_pane';
export const TICKER_FLOW_EXPAND_PANE = 'ticker_flow_expand_pane';
export const TICKER_FLOW_RESTORE_PANE = 'ticker_flow_restore_pane';
export const OPC_EXPAND_PANE = 'opc_expand_pane';
export const OPC_RESTORE_PANE = 'opc_restore_pane';
export const CLICK_UPGRADE = 'click_upgrade';
export const SAVE_STRATEGIES = 'save_strategies';
export const NEWSLETTER_SHARE_OPENED = 'newsletter_share_opened';
export const FLOW_AI_ANALYSIS_OPENED = 'flow_ai_analysis_opened';
export const FLOW_AI_ANALYSIS_DOWNLOADED = 'flow_ai_analysis_downloaded';
export const PARITY_OFFER_CHECKED = 'parity_offer_checked';
export const PARITY_CODE_COPIED = 'parity_code_copied';
export const PARITY_CHECKOUT_CLICKED = 'parity_checkout_clicked';
/**
 * A free or anonymous viewer picked a ticker-flow date filter other than Latest and hit the paywall.
 * `preset` is the preset key (`week`, `twoWeeks` or `month`), or null for a custom range, which
 * carries `startDate` and `endDate` (yyyy-MM-dd).
 */
export const HISTORICAL_FLOW_GATE_SHOWN = 'historical_flow_gate_shown';
/**
 * A free or signed-out viewer reached a GEX close outside their free window (the ticker's 5 most
 * recent closes) and hit the paywall. `trigger` is `picker`, `step` (the ‹ › arrows) or `link` (a
 * shared URL answered 403); `date` is the close (yyyy-MM-dd).
 */
export const HISTORICAL_GEX_GATE_SHOWN = 'historical_gex_gate_shown';
/**
 * A click on the GEX page's Download CSV button, once it resolves: `hasAccess` true started the file,
 * false opened the subscribe popup (the CSV is a subscriber feature, as on the Flow pages). `date` is
 * the close on screen (yyyy-MM-dd), or null for Latest. A click made while the sign-in restores is
 * recorded when the plan arrives; one whose sign-in never resolves is not recorded (D29's rule).
 */
export const DOWNLOAD_GEX = 'download_gex';
export const MEMBER_OFFER_OPENED = 'member_offer_opened';
export const MEMBER_OFFER_QUOTED = 'member_offer_quoted';
export const MEMBER_OFFER_CONFIRMED = 'member_offer_confirmed';
export const MEMBER_SALE_PRESENTED = 'member_sale_presented';
export const MEMBER_SALE_DISMISSED = 'member_sale_dismissed';
/** The member pressed "No thanks" (`source`: card, bar or dialog) or left from the Before-you-go step. */
export const MEMBER_OFFER_DECLINED = 'member_offer_declined';
/** "No thanks" opened the Before-you-go step of an offer with a real end date. */
export const MEMBER_OFFER_DECLINE_OPENED = 'member_offer_decline_opened';
/** The modal closed with no decision: the close button, Escape or the backdrop. */
export const MEMBER_OFFER_CLOSED = 'member_offer_closed';
